import { render } from "./Projects.vue?vue&type=template&id=57e2b2b3"
import script from "./Projects.vue?vue&type=script&lang=ts"
export * from "./Projects.vue?vue&type=script&lang=ts"

import "./Projects.vue?vue&type=style&index=0&id=57e2b2b3&lang=scss"
script.render = render

export default script